module.exports = __webpack_public_path__ + "static/media/greyCIcon.53b376b6.svg";